// extracted by mini-css-extract-plugin
module.exports = {"SmallNavigation":"SmallNavigation_SmallNavigation__2wvH7","NavItem":"SmallNavigation_NavItem__1T-yo"};